export type ThemeName = "sc" | "poly";

/**
 * 主题 token：key 为 CSS 变量名（不带 --），value 为 CSS 变量值。
 * 约定：仅放“设计语义 token”，组件通过 var(--token) 消费。
 */
export type ThemeTokens = Record<string, string>;

export type ThemeDefinition = {
  name: ThemeName;
  tokens: ThemeTokens;
};

/**
 * sc：当前线上紫色皮肤（来自现有弹窗硬编码值的抽取）
 */
export const sc: ThemeDefinition = {
  name: "sc",
  tokens: {
    "betby-modal-bg-inner": "#1F1135",
    "betby-modal-border-start": "#8E27D8",
    "betby-modal-border-mid": "#441368",
    "betby-modal-border-end": "#7220AC",
    "betby-modal-primary-start": "#9C4DFF",
    "betby-modal-primary-end": "#7B2FDC",
    "betby-modal-primary-shadow": "rgba(123, 47, 220, 0.4)",
    "betby-modal-text-title": "#ffffff",
    "betby-modal-text-desc": "rgba(255, 255, 255, 0.8)",
    "betby-modal-primary-text": "#ffffff",
  },
};

/**
 * poly：黑黄皮肤（先给占位值，细节待设计稿）
 */
export const poly: ThemeDefinition = {
  name: "poly",
  tokens: {
    "betby-modal-bg-inner": "#23272E",
    "betby-modal-border-start": "transparent",
    "betby-modal-border-mid": "transparent",
    "betby-modal-border-end": "transparent",
    "betby-modal-primary-start": "#FFDD00",
    "betby-modal-primary-end": "#ffa600",
    "betby-modal-primary-shadow": "none",
    "betby-modal-text-title": "#ffffff",
    "betby-modal-text-desc": "#929497",
    "betby-modal-primary-text": "#23272E",
  },
};

export const themes: Record<ThemeName, ThemeDefinition> = {
  sc,
  poly,
};
